import { render } from "./EditPriceModal.vue?vue&type=template&id=ecf25bb0&scoped=true"
import script from "./EditPriceModal.vue?vue&type=script&lang=js"
export * from "./EditPriceModal.vue?vue&type=script&lang=js"

import "./EditPriceModal.vue?vue&type=style&index=0&id=ecf25bb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf25bb0"]])

export default __exports__